module.exports = __webpack_public_path__ + "static/media/ApproveIcon.7ecd6a33.svg";